import { defineMessages } from 'react-intl';
import TermsPrivacy from '../../components/_Site/CA/TermsPrivacy';
import TermsPrivacyFr from '../../components/_Site/CA/TermsPrivacyFr';
import TermsPrint from '../../components/_Site/CA/TermsPrint';
import TermsAdditional from '../../components/_Site/CA/TermsAdditional';
import TermsAdditionalFr from '../../components/_Site/CA/TermsAdditionalFr';

const messages = defineMessages({
  emailTerms: {
    id: 'ca.emailTerms',
    defaultMessage: 'Terms of Use & Privacy Policy',
    description: 'ca.emailTerms',
  },
  emailAdditionalTerms: {
    id: 'ca.emailAdditionalTerms',
    defaultMessage: 'Additional Terms of Use & Privacy Supplement',
    description: 'ca.emailAdditionalTerms',
  },
  emailPrintcenterTerms: {
    id: 'ca.emailPrintcenterTerms',
    defaultMessage: 'PrintCenter Terms of Use & Privacy Policy',
    description: 'ca.emailPrintcenterTerms',
  },

  english: {
    id: 'ca.english',
    defaultMessage: 'English',
    description: 'ca.english',
  },
  french: {
    id: 'ca.french',
    defaultMessage: 'French',
    description: 'ca.french',
  },

  shippingStandard: {
    id: 'ca.shippingStandard',
    defaultMessage:
      'Standard Delivery (5 to 7 business days to most delivery locations in Canada) ',
    description: 'ca.shippingStandard',
  },
  shippingDownload: {
    id: 'ca.shippingDownload',
    defaultMessage: 'Digital Download',
    description: 'ca.shippingDownload',
  },

  generalTerms: {
    id: 'ca.generalTerms',
    defaultMessage: 'Terms of Use and Privacy Policy',
    description: 'ca.generalTerms',
  },
  additionalTerms: {
    id: 'ca.additionalTerms',
    defaultMessage: 'MYSKP Additional Terms of Use and Privacy Supplement',
    description: 'ca.additionalTerms',
  },
  printCenterTerms: {
    id: 'ca.printCenterTerms',
    defaultMessage: 'Print Center Terms',
    description: 'ca.printCenterTerms',
  },

  footerTrending: {
    id: 'ca.footerTrending',
    defaultMessage: 'Trending',
    description: 'ca.footerTrending',
  },
  footerEducation: {
    id: 'ca.footerEducation',
    defaultMessage: 'Education',
    description: 'ca.footerEducation',
  },
  footerProducts: {
    id: 'ca.footerProducts',
    defaultMessage: 'Products',
    description: 'ca.footerProducts',
  },
  footerMobileApps: {
    id: 'ca.footerMobileApps',
    defaultMessage: 'Mobile Apps',
    description: 'ca.footerMobileApps',
  },
  footerHelp: {
    id: 'ca.footerHelp',
    defaultMessage: 'Help',
    description: 'ca.footerHelp',
  },

  footerLatestInnovations: {
    id: 'ca.footerLatestInnovations',
    defaultMessage: 'Latest Innovations',
    description: 'ca.footerLatestInnovations',
  },
  footerEssentialLooks: {
    id: 'ca.footerEssentialLooks',
    defaultMessage: 'Essential Looks',
    description: 'ca.footerEssentialLooks',
  },
  // footerASKBrouchure: {
  //   id: 'ca.footerASKBrouchure',
  //   defaultMessage: 'ASK Brouchure',
  //   description: 'ca.footerASKBrouchure',
  // },
  footerEAcademy: {
    id: 'ca.footerEAcademy',
    defaultMessage: 'eAcademy',
    description: 'ca.footerEAcademy',
  },
  footerSeminars: {
    id: 'ca.footerSeminars',
    defaultMessage: 'Seminars',
    description: 'ca.footerSeminars',
  },
  footerHairColor: {
    id: 'ca.footerHairColor',
    defaultMessage: 'Hair Color',
    description: 'ca.footerHairColor',
  },
  footerHairCare: {
    id: 'ca.footerHairCare',
    defaultMessage: 'Hair Care',
    description: 'ca.footerHairCare',
  },
  footerHairStyling: {
    id: 'ca.footerHairStyling',
    defaultMessage: 'Hair Styling',
    description: 'ca.footerHairStyling',
  },
  footerHouseOfColor: {
    id: 'ca.footerHouseOfColor',
    defaultMessage: 'House of Color',
    description: 'ca.footerHouseOfColor',
  },
  footerHairExpert: {
    id: 'ca.footerHairExpert',
    defaultMessage: 'Hair Expert',
    description: 'ca.footerHairExpert',
  },
  footerFaq: {
    id: 'ca.footerFaq',
    defaultMessage: 'FAQ',
    description: 'ca.footerFaq',
  },
  footerSupport: {
    id: 'ca.footerSupport',
    defaultMessage: 'Support',
    description: 'ca.footerSupport',
  },
  footerContact: {
    id: 'ca.footerContact',
    defaultMessage: 'Contact',
    description: 'ca.footerContact',
  },
  hairdressingSchool: {
    id: 'salondb.edit.hairdressingSchool',
    defaultMessage: 'Hairdressing School',
    description: 'salondb.edit.hairdressingSchool',
  },
  homeSalon: {
    id: 'salondb.edit.homeSalon',
    defaultMessage: 'Home Salon',
    description: 'salondb.edit.homeSalon',
  },
  retailOutlet: {
    id: 'salondb.edit.retailOutlet',
    defaultMessage: 'Retail Outlet',
    description: 'salondb.edit.retailOutlet',
  },
  distributorStore: {
    id: 'salondb.edit.distributorStore',
    defaultMessage: 'Distributor Store',
    description: 'salondb.edit.distributorStore',
  },
  vipSalon: {
    id: 'salondb.edit.vipSalon',
    defaultMessage: 'VIP Salon',
    description: 'salondb.edit.vipSalon',
  },
  traditionalSalon: {
    id: 'salondb.edit.traditionalSalon',
    defaultMessage: 'Traditional Salon',
    description: 'salondb.edit.traditionalSalon',
  },
});

export default {
  id: 'ca',
  suffix: 'ca',
  email: {
    defaultFrom: 'notifications@henkelbeautypro.com',
    defaultReplyTo: ['hello@clubh.ca'],
    clubhFrom: 'hello@clubh.ca',
    clubhReplyTo: ['hello@clubh.ca'],
  },
  orderCc: ['hello@clubh.ca'],
  printCenterCc: ['printcenter@clubh.ca'],
  userSignupBcc: ['signups-ca@henkelbeautypro.com'],
  educationNotificationEmail: [],
  label: 'Canada',
  klaviyoListId: process.env.APP_ENV === 'master' ? 'WvJ4rS' : 'VAgXRU',
  company: 'Henkel Consumer Brands Canada Corporation',
  companyShort: 'Henkel Consumer Brands Canada Corporation',
  emailFooterLinks: [
    // do not prepend host name
    {
      label: 'Terms of Use & Privacy Policy',
      // label: intl.formatMessage(messages.emailTerms),
      href: '/ca/#terms',
    },
    {
      label: 'Additional Terms of Use & Privacy Supplement',
      // label: intl.formatMessage(messages.emailAdditionalTerms),
      href: '/ca/#additional-terms',
    },
    {
      label: 'PrintCenter Terms of Use & Privacy Policy',
      // label: intl.formatMessage(messages.emailPrintcenterTerms),
      href: '/ca/#printcenter-terms',
    },
  ],
  flag: 'icon-flag--canada',
  locales: {
    'en-CA': {
      label: 'English',
    },
    'fr-CA': {
      label: 'French',
    },
  },
  localesIntl(intl) {
    return {
      'en-CA': {
        label: intl.formatMessage(messages.english),
      },
      'fr-CA': {
        label: intl.formatMessage(messages.french),
      },
    };
  },
  countries: [
    { label: 'Canada', value: 'CA', threeChar: 'CAN', default: true },
  ],
  social: {
    facebook: 'https://www.facebook.com/clubhrewards',
    instagram: 'https://www.instagram.com/clubhrewards',
    // twitter: 'https://twitter.com/SKPprofessional',
    // pinterest: 'http://pinterest.com/Schwarzkopfpro',
    youtube: 'https://www.youtube.com/@ClubHrewards',
    tiktok: 'https://www.tiktok.com/clubhrewards',
  },
  baseCurrency: 'CAD',
  shippingOptions: {
    'flatrate-standard': {
      label:
        'Standard Delivery (5 to 7 business days to most delivery locations in Canada) ',
      // label: intl.formatMessage(messages.shippingStandard),
      amount: 0,
    },
    'digital-download': {
      label: 'Digital Download',
      // label: intl.formatMessage(messages.shippingDownload),
      amount: 0,
    },
  },
  shippingPrintCenter: {
    amount: 1500,
  },
  currencies: [
    {
      code: 'CAD',
      label: 'CAD',
    },
    {
      code: 'POINTS',
      label: 'Points',
    },
  ],
  units: {
    distance: {
      label: 'Kilometer',
      abbrev: 'Km',
    },
  },
  contact: {
    address: {
      str1: '2515 Meadowpine Blvd',
      city: 'Mississauga',
      state: 'ON',
      postal: 'L5N 6C3',
      country: 'CANADA',
    },
    phone: '905-816-4631',
    fax: '905-826-8611',
    email: 'clubskp@henkelbeautypro.com',
    website: 'henkelbeautypro.com',
    support: '',
  },
  loyalty: {
    tz: 'America/Los_Angeles',
    rollingExpiry: [13, 'months'], // passed into moment.subtract(...rollingExpiry)
    // DEPRECATED
    // pointsExpireMoment: {
    //   month: 1, // jan = 0, dec = 11
    //   date: 1,
    //   startOf: 'day',
    //   tz: 'America/Los_Angeles',
    // },
  },
  taxRates: {
    CA: {
      AB: 0.05,
      BC: 0.12,
      MB: 0.13,
      NB: 0.15,
      NL: 0.15,
      NS: 0.15,
      NT: 0.05,
      NU: 0.05,
      ON: 0.13,
      PE: 0.15,
      QC: 0.14975,
      SK: 0.1,
      YT: 0.05,
    },
  },
  terms(intl) {
    return {
      // generalTerms is a required field
      generalTerms: {
        label: intl.formatMessage(messages.generalTerms),
        component: intl.locale === 'fr-CA' ? TermsPrivacyFr : TermsPrivacy,
        props: [],
      },
      additionalTerms: {
        label: intl.formatMessage(messages.additionalTerms),
        component:
          intl.locale === 'fr-CA' ? TermsAdditionalFr : TermsAdditional,
        props: [],
      },
      printCenterTerms: {
        label: intl.formatMessage(messages.printCenterTerms),
        component: TermsPrint,
        props: [],
      },
    };
  },
  salonCategories(intl) {
    return [
      {
        value: '',
        label: '',
      },
      {
        value: 'Hairdressing School',
        label: intl.formatMessage(messages.hairdressingSchool),
      },
      {
        value: 'Home Salon',
        label: intl.formatMessage(messages.homeSalon),
      },
      {
        value: 'Retail Outlet',
        label: intl.formatMessage(messages.retailOutlet),
      },
      {
        value: 'Distributor Store',
        label: intl.formatMessage(messages.distributorStore),
      },
      {
        value: 'VIP Salon',
        label: intl.formatMessage(messages.vipSalon),
      },
      {
        value: 'Traditional Salon',
        label: intl.formatMessage(messages.traditionalSalon),
      },
    ];
  },
  footer(intl) {
    return [
      // {
      //   label: intl.formatMessage(messages.footerTrending),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerLatestInnovations),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/latest-innovations.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerEssentialLooks),
      //       to: 'https://www.essentiallooks.com/',
      //     },
      //     // {
      //     //   label: 'Essential Looks',
      //     //   to: 'http://www.schwarzkopf-professional.ca/skp/ca/en/home.html',
      //     // },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerEducation),
      //   links: [
      //     // {
      //     //   label: intl.formatMessage(messages.footerASKBrouchure),
      //     //   to:
      //     //     'https://myskp-printcenter.nyc3.digitaloceanspaces.com/ask/ASK_Academy_Brochure_CAN.pdf',
      //     // },
      //     {
      //       label: intl.formatMessage(messages.footerEAcademy),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/education/ask-education-eacademy.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerSeminars),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/education/seminars.html',
      //     },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerProducts),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerHairColor),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/color.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerHairCare),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/care.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerHairStyling),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/styling.html',
      //     },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerMobileApps),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerHouseOfColor),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/color/house-of-color.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerEssentialLooks),
      //       to: 'https://www.essentiallooks.com/',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerHairExpert),
      //       to:
      //         'https://www.schwarzkopf-professional.ca/en/home/products/care/hair-expert.html',
      //     },
      //     // {
      //     //   label: 'ASK Academy',
      //     //   to:
      //     //     'http://www.schwarzkopf-professional.ca/skp/ca/en/home/education/ask.html',
      //     // },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerHelp),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerFaq),
      //       to: 'https://myskp-ca.zendesk.com/hc/en-us',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerSupport),
      //       to: 'https://myskp-ca.zendesk.com/hc/en-us/requests/new',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerContact),
      //       to: 'https://myskp-ca.zendesk.com/hc/en-us/requests/new',
      //     },
      //   ],
      // },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/configs/sites/ca.js